<template>

    <v-menu

    >
        <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
                <v-badge
                        v-if="$store.state.notifications.length>0 || $store.state.newcontent"
                        color="info">
                    <template v-slot:badge>
                        <span>{{$store.state.notifications.length + $store.state.newcontent?1:0}}</span>
                    </template>
                    <v-icon color="grey">far fa-bell</v-icon>
                </v-badge>
            </v-btn>
        </template>

        <v-list>
            <v-list-item v-if="$store.state.newcontent" @click="window.location.reload(true)">
                <v-list-item-icon>
                    <v-icon>fas fa-sync-alt</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>
                        New content available...
                    </v-list-item-title>
                </v-list-item-content>

            </v-list-item>
            <v-list-item
                    v-for="n in $store.state.notifications"
                    :key="n.text"
                    @click="() => {}"
                    :to="n.to"
            >
                <v-list-item-avatar v-if="n.logo">
                    <img :src="n.logo" />
                </v-list-item-avatar>
                <v-list-item-icon v-else>
                    <v-icon>{{n.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                    {{n.text}}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
  export default {
    components: {},
    name: "NoteBell",
    data() {
      return {
        window:false
      }
    },
    mounted() {
      this.window = window;
    },
    methods: {}
  }
</script>

<style scoped>

</style>